import React, {useState} from "react";
import {Link} from 'react-router-dom';

import "./Navbar.css";

import HamIcon from "../assets/images/HamIcon.png";
import XIcon from "../assets/images/Xicon.png";

/* I followed the first 20 minutes of this tutorial so I could get a grasp on how to create a navigation menu: https://www.youtube.com/watch?v=I2UBjN5ER4s. */

function Navbar()
{
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    return(
        <div>
            <nav className="navbar">
                <div className="navbar-container">
                    <Link to="/" className="navbar-image">
                        Home
                    </Link>
                    <div className="menu-image" onClick={handleClick}>
                    <img
                        src={click ? XIcon : HamIcon}
                        alt="Menu Toggle"
                        className="menu-image"
                        width={30}
                        height={30}
                    />
                    </div>
                    <ul className={click ? "nav-menu active" : "nav-menu"}>
                        <li className="nav-item">
                            <Link to="/information" className="navbar-links" onClick={closeMobileMenu}>
                                Contact
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/about" className="navbar-links" onClick={closeMobileMenu}>
                                About
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/education" className="navbar-links" onClick={closeMobileMenu}>
                                Education
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/skills" className="navbar-links" onClick={closeMobileMenu}>
                                Skills
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link to="/projects" className="navbar-links" onClick={closeMobileMenu}>
                                Projects
                            </Link>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    )

}

export default Navbar